<template>
	<div class="members-rewards">
		<h3>Member Rewards</h3>

		<div class="members">
			<input name="memberID" placeholder="Member ID (Press Enter)" v-model="memberID" v-on:keyup.enter="getMember" autocomplete="off" />

			<div v-if="memberInfo" class="memberInfo">
				<div>
					<p class="header">NAME:</p>
					<p>{{ memberInfo.name }}</p>
				</div>

				<div>
					<p class="header">CARD NUMBER:</p>
					<p>{{ memberInfo.card_number }}</p>
				</div>

				<div>
					<p class="header">POINTS:</p>
					<p>{{ memberInfo.points }}</p>
				</div>
			</div>

			<div v-if="selectedGifts.length > 0" class="rewards">
				<h3>Selected Gifts</h3>
				<div v-for="(item, index) of selectedGifts" v-bind:key="index" class="rewards-list">
					<div>{{ item.name }}</div>
					<div>{{ item.points }}</div>
					<div @click="removeRewards(index, item.points)" class="remove-button">REMOVE</div>
				</div>

				<button class="submit-button" :disabled="isLoading" @click="submit()">SAVE</button>

				<br /><br />
			</div>

			<div v-if="rewards.length > 0" class="rewards">
				<h3>Available Gifts (Available Points: {{ tempPoints }})</h3>
				<div v-for="(item, index) of rewards" v-bind:key="index" class="rewards-list">
					<div>{{ item.name }}</div>
					<div>{{ item.points }}</div>
					<div @click="addRewards(item)" class="add-button" v-if="tempPoints >= item.points">ADD</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'settings',

	data: function() {
		return {
			memberID: null,
			memberInfo: null,
			rewards: [],
			selectedGifts: [],
			tempPoints: 0,
			isLoading: false,

			branchName: null,
			ranchPhoneNumber: null
		}
	},

	watch: {},

	mounted: async function() {},

	methods: {
		// Get brach info
		getBranchInfo: async function() {
			// Get data from info api
			const apiInfo = await this.$api.branchInfo()

			if (apiInfo !== undefined) {
				// Assign data
				let data = apiInfo.data['static-values'].configs.shops.entity

				// Assign branch name. Branch name is required
				this.branchName = data.name

				if (data.mobile_phone) {
					this.branchPhoneNumber = data.mobile_phone
				} else {
					this.branchPhoneNumber = this.$config.brandPhone
				}
			} else {
				// If error, set default values
				this.branchName = this.$config.branchName
				this.branchPhoneNumber = this.$config.brandPhone
			}
		},

		submit: async function() {
			if (this.selectedGifts.length > 0) {
				this.isLoading = true

				let data = {
					customer: this.memberInfo._id,
					selectedProducts: []
				}

				this.selectedGifts.map(product => {
					data.selectedProducts.push(product.reward._id)
				})

				let checkout = await this.$api.rewardCheckout({ data })

				// Show messages
				if (checkout && checkout.data.ok == 1) {
					this.$swal.fire({ position: 'top-end', icon: 'success', title: 'Reward has been saved!', showConfirmButton: false, timer: 1500 })

					// Reset default
					this.memberID = null
					this.clean()
				} else {
					this.$swal.fire({ position: 'top-end', icon: 'error', title: 'Something is wrong!', showConfirmButton: true, timer: 3500 })
				}

				this.isLoading = false
			}
		},

		// To remove rewards
		removeRewards: async function(key, points) {
			this.tempPoints += points

			this.selectedGifts.splice(key, 1)
		},

		// To add rewards
		addRewards: async function(item) {
			this.tempPoints -= item.points
			this.selectedGifts.push(item)
		},

		// Clean states
		clean: function() {
			this.memberInfo = null
			this.rewards = []
			this.selectedGifts = []
			this.tempPoints = 0
		},

		print: function() {
			this.$printd.print(document.getElementById('printing'), [this.cssText])
		},

		// Reset server setting
		getMember: async function() {
			this.clean()

			// Make sure member id isn't blank
			if (this.memberID == null) {
				this.$swal.fire('Error!', 'Member ID cannot be blanked', 'error')

				return
			}

			// Set data
			let data = {
				card_number: this.memberID
			}

			const apiSearchMember = await this.$api.getMember({ data })

			if (!apiSearchMember || !apiSearchMember.data) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Invalid Member ID'
				})

				return
			} else {
				const customer = apiSearchMember.data
				this.memberInfo = customer
				this.tempPoints = customer.points

				if (customer && customer.points > 0) {
					let reward_data = {
						points: customer.points
					}

					const rewards = await this.$api.getRewards({ data: reward_data })

					if (rewards && rewards.data.count > 0) {
						rewards.data.list.map(reward => {
							reward.products.map(async product => {
								if (product) {
									let data = {
										id: product
									}

									const detail = await this.$api.getProductDetail({ data })

									if (detail) {
										detail.data.reward = reward
										detail.data.points = reward.points

										this.rewards.push(detail.data)
									}
								}
							})
						})
					}
				}
			}
		}
	}
}
</script>

<style scoped>
.members {
	font-size: 13px;
	font-family: 'poppinssemibold';
	color: #000;
}

h3 {
	margin: 20px;
}

.members input {
	border-radius: 5px;
	height: 40px;
	width: 350px;
	padding: 0 10px;
	font-size: 13px;
	margin-bottom: 20px;
	-webkit-box-shadow: 0px 0px 5px 0px rgb(201, 238, 250);
	-moz-box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	font-family: 'poppinssemibold';
	border: 1px solid #d5e3f5;
	background-color: #fff;
}

.memberInfo {
	width: 500px;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	margin: 20px auto;
}

.header {
	font-size: 13px;
	font-family: 'poppinsbold';
	color: #aaa;
}

.rewards-list {
	width: 800px;
	display: grid;
	text-align: left;
	grid-template-columns: 1fr 100px 100px;
	margin: 10px auto 10px;
	padding: 10px;
	border-bottom: 1px solid #ccc;
}

.add-button {
	background-color: #62c7c2;
	text-align: center;
	padding: 5px 0;
	border: 1px solid #62c7c2;
	border-radius: 3px;
	color: #fff;
	cursor: pointer;
}

.remove-button {
	background-color: red;
	text-align: center;
	padding: 5px 0;
	border: 1px solid red;
	border-radius: 3px;
	color: #fff;
	cursor: pointer;
}

.submit-button {
	margin: auto;
	background-color: #62c7c2;
	text-align: center;
	padding: 20px 0;
	border: 1px solid #62c7c2;
	border-radius: 3px;
	color: #fff;
	cursor: pointer;
	width: 100px;
}
</style>
